import { Button } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";

import style from "./PasswordResetError.module.css";

interface PasswordResetErrorProps {
  onBackToLoginClick: () => void;
  onTryAgainClick: () => void;
}

const PasswordResetError = (props: PasswordResetErrorProps) => {
  const { t, m } = useTranslation();

  return (
    <div className={style.passwordResetError}>
      <div className={style.modalContainer}>
        <Heading type="h1">{t(m.ResetPassword.ErrorTitle)}</Heading>
        <div>
          <p>{t(m.ResetPassword.ErrorMessage)}</p>
        </div>
        <div className={classNames(style.footer)}>
          <Button className="tryAgainButton" onClick={props.onTryAgainClick}>
            {t(m.ResetPassword.TryAgain)}
          </Button>
          <Button
            className="backToLoginButton"
            onClick={props.onBackToLoginClick}
            variant="grayscale"
          >
            {t(m.ResetPassword.BackToLogin)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetError;
